import ProjectNotesAPI from '../../api/projectNotes';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getNotesByProject: _state => projectId => {
    const records = _state.records[projectId] || [];
    return [...records].sort((r1, r2) => r2.id - r1.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { projectId }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ProjectNotesAPI.get(projectId);
      commit('setNotes', { projectId, data });
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, { projectId, content }) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await ProjectNotesAPI.create(projectId, content);
      commit('addNote', { projectId, data });
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async delete({ commit }, { projectId, noteId }) {
    commit('setUIFlag', { isDeleting: true });
    try {
      await ProjectNotesAPI.delete(projectId, noteId);
      commit('deleteNote', { projectId, noteId });
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  setNotes($state, { projectId, data }) {
    $state.records = { ...$state.records, [projectId]: data };
  },
  addNote($state, { projectId, data }) {
    const notes = $state.records[projectId] || [];
    $state.records = { ...$state.records, [projectId]: [data, ...notes] };
  },
  deleteNote($state, { projectId, noteId }) {
    const notes = $state.records[projectId] || [];
    $state.records = {
      ...$state.records,
      [projectId]: notes.filter(note => note.id !== noteId),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
